// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D23CJZ {
  position: absolute;
  z-index: 1000;
}

.sTZR9H {
  position: relative;
}

.eLwwgJ {
  font-size: 20px;
  line-height: 26px;
  text-align: left;
  width: 100%;
}

.lfsTgA {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
}

.t9u2Xr {
  width: 100%;
}

.WTIVe8 {
  width: 45%;
}

.d0Jbfu {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 14px;
}

.HHAg7B {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  width: 100%;
  padding: 12px 20px;
  border: 1px solid #cccccc;
  background: #fafafa;
  border-radius: var(--ibk-radius-s, 4px);
}

.tRRyEZ {
  opacity: 0.8;
  border: none;
  font-size: var(--type-title-md-font-size);
  color: var(--text-neutral-dark);
  font-weight: var(--font-weight-regular);
  background-color: transparent;
  outline: none;
  width: 100%;
}

.M2gQh8 {
  position: absolute;
  top: 60px;
  left: 0;
  z-index: 1000;
  width: 272px;
  padding: var(--spacing-lg, 24px);
  border: 1px solid var(--ibk-colors-neutral-400, #e6e6e6);
  border-radius: var(--ibk-radius-s, 4px);
  background: var(--ibk-colors-neutral-100, #fff);
  box-shadow: var(--ibk-shadow-md, 0 2px 4px rgba(0, 0, 0, 0.12));
  height: 290px;
  box-sizing: border-box;
}

.M2gQh8::before {
  content: '';
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 12px solid var(--ibk-colors-neutral-400, #e6e6e6);
}

.M2gQh8::after {
  content: '';
  position: absolute;
  top: -11px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 13px solid transparent;
  border-right: 13px solid transparent;
  border-bottom: 11px solid var(--ibk-colors-neutral-100, #ffffff);
}

.GJahTR {
  cursor: pointer;
}

.u_ATf_ {
  margin: 0 12px;
}

.o3KFE6 {
  display: grid;
  grid-template-columns: 24px 0.5fr 24px;
  align-items: center;
  margin-bottom: 16px;
  height: 40px;
  justify-content: center;
}

.ds6XMP {
  font-family: var(--ibk-typography-fontFamilyBase, 'Source Sans 3');
  font-weight: var(--ibk-typography-fontWeightSemiBold, 600);
  font-style: normal;
  font-size: var(--ibk-typography-fontSizeSm, 12px);
  line-height: 100%;
  letter-spacing: 0;
  color: var(--ibk-colors-primary-orange-500, #d64000);
  text-align: center;
}

.Yu8NI9 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  margin-bottom: 8px;
  height: 24px;
}

.Yu8NI9 > div {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--type-paragraph-md-font-size, 12px);
  color: var(--text-neutral-dark, #1f1f1f);
  line-height: 100%;
}

.oSolqN {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.ygdXHp {
  width: var(--ibk-spacing-xxl, 64px);
  height: var(--ibk-spacing-lg, 32px);
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: var(--ibk-colors-neutral-400, #e6e6e6);
  border-radius: var(--ibk-radius-pill, 100px);
  cursor: pointer;
  font-family: var(--ibk-typography-fontFamilyBase, 'Source Sans 3', sans-serif);
  font-weight: var(--ibk-typography-fontWeightRegular, 400);
  font-size: var(--ibk-typography-fontSizeMd, 16px);
  line-height: var(--ibk-typography-lineHeight160, 1.6);
  color: var(--ibk-colors-neutral-900, #1f1f1f);
}

.kqunSL {
  opacity: 0.5;
  cursor: not-allowed;
}

.gySQ8y {
  background: var(--ibk-colors-primary-orange-100, #ffeee5);
  color: var(--ibk-colors-primary-orange-500, #d64000);
  border: 1px solid var(--ibk-colors-primary-orange-500, #d64000);
  gap: var(--ibk-spacing-xs, 4px);
}

.J5ux14 {
  height: var(--ibk-spacing-md, 16px);
  width: var(--ibk-spacing-md, 16px);
  color: var(--ibk-colors-primary-orange-500, #d64000);
  text-align: center;
  font-size: var(--ibk-typography-fontSizeSm, 12px);
  background: transparent;
  border: 1px solid var(--ibk-colors-primary-orange-500, #d64000);
  cursor: pointer;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.euzGGJ {
  width: var(--ibk-spacing-xs, 8px);
  height: var(--ibk-spacing-xs, 8px);
  filter: var(--ibk-colors-primary-orange-filter, var(--primary-orange-filter));
}

.joThtC {
  border: none;
  background: transparent;
  color: var(--ibk-colors-primary-orange-500, #d64000);
  font-size: var(--ibk-typography-fontSizeMd, 18px);
  line-height: 1;
  cursor: pointer;
  width: var(--ibk-spacing-lg, 24px);
  height: var(--ibk-spacing-lg, 24px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.g5EJMI {
  display: flex;
  justify-content: flex-end;
}

.d0zEsr {
  height: 24px;
  padding-right: var(--spacing-1-5);
  padding-left: var(--spacing-1-5);
  border-radius: var(--button-border-radius);
  background: var(--brand-tr-orange);
  border: 2px solid var(--brand-tr-orange);
  color: var(--text-neutral-white);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--ibk-typography-fontSizeSm, 12px);
  cursor: pointer;
}

/* Disabled styles */
.LpmVgB .HHAg7B {
  border: none;
}

.LpmVgB .tRRyEZ {
  color: var(--disabled-subtle-text);
  cursor: not-allowed;
}

.LpmVgB .GJahTR {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/MonthCalendar/MonthCalendar.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,+BAA+B;EAC/B,uCAAuC;EACvC,6BAA6B;EAC7B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,YAAY;EACZ,gCAAgC;EAChC,wDAAwD;EACxD,uCAAuC;EACvC,+CAA+C;EAC/C,+DAA+D;EAC/D,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,gEAAgE;AAClE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kEAAkE;EAClE,0DAA0D;EAC1D,kBAAkB;EAClB,iDAAiD;EACjD,iBAAiB;EACjB,iBAAiB;EACjB,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;EAC7C,mDAAmD;EACnD,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kDAAkD;EAClD,4CAA4C;EAC5C,eAAe;EACf,8EAA8E;EAC9E,yDAAyD;EACzD,iDAAiD;EACjD,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yDAAyD;EACzD,oDAAoD;EACpD,+DAA+D;EAC/D,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,oDAAoD;EACpD,kBAAkB;EAClB,iDAAiD;EACjD,uBAAuB;EACvB,+DAA+D;EAC/D,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,6EAA6E;AAC/E;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,oDAAoD;EACpD,iDAAiD;EACjD,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,mCAAmC;EACnC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,gCAAgC;EAChC,0CAA0C;EAC1C,kCAAkC;EAClC,wCAAwC;EACxC,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,iDAAiD;EACjD,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".popper {\n  position: absolute;\n  z-index: 1000;\n}\n\n.popperContainer {\n  position: relative;\n}\n\n.title {\n  font-size: 20px;\n  line-height: 26px;\n  text-align: left;\n  width: 100%;\n}\n\n.fields {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 16px;\n}\n\n.singleField {\n  width: 100%;\n}\n\n.periodField {\n  width: 45%;\n}\n\n.label {\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 14px;\n}\n\n.textInputAndSvg {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 48px;\n  width: 100%;\n  padding: 12px 20px;\n  border: 1px solid #cccccc;\n  background: #fafafa;\n  border-radius: var(--ibk-radius-s, 4px);\n}\n\n.textInput {\n  opacity: 0.8;\n  border: none;\n  font-size: var(--type-title-md-font-size);\n  color: var(--text-neutral-dark);\n  font-weight: var(--font-weight-regular);\n  background-color: transparent;\n  outline: none;\n  width: 100%;\n}\n\n.calendar {\n  position: absolute;\n  top: 60px;\n  left: 0;\n  z-index: 1000;\n  width: 272px;\n  padding: var(--spacing-lg, 24px);\n  border: 1px solid var(--ibk-colors-neutral-400, #e6e6e6);\n  border-radius: var(--ibk-radius-s, 4px);\n  background: var(--ibk-colors-neutral-100, #fff);\n  box-shadow: var(--ibk-shadow-md, 0 2px 4px rgba(0, 0, 0, 0.12));\n  height: 290px;\n  box-sizing: border-box;\n}\n\n.calendar::before {\n  content: '';\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 14px solid transparent;\n  border-right: 14px solid transparent;\n  border-bottom: 12px solid var(--ibk-colors-neutral-400, #e6e6e6);\n}\n\n.calendar::after {\n  content: '';\n  position: absolute;\n  top: -11px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 13px solid transparent;\n  border-right: 13px solid transparent;\n  border-bottom: 11px solid var(--ibk-colors-neutral-100, #ffffff);\n}\n\n.calendarIcon {\n  cursor: pointer;\n}\n\n.arrow {\n  margin: 0 12px;\n}\n\n.calendarHeader {\n  display: grid;\n  grid-template-columns: 24px 0.5fr 24px;\n  align-items: center;\n  margin-bottom: 16px;\n  height: 40px;\n  justify-content: center;\n}\n\n.yearTitle {\n  font-family: var(--ibk-typography-fontFamilyBase, 'Source Sans 3');\n  font-weight: var(--ibk-typography-fontWeightSemiBold, 600);\n  font-style: normal;\n  font-size: var(--ibk-typography-fontSizeSm, 12px);\n  line-height: 100%;\n  letter-spacing: 0;\n  color: var(--ibk-colors-primary-orange-500, #d64000);\n  text-align: center;\n}\n\n.weekdays {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  text-align: center;\n  margin-bottom: 8px;\n  height: 24px;\n}\n\n.weekdays > div {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--type-paragraph-md-font-size, 12px);\n  color: var(--text-neutral-dark, #1f1f1f);\n  line-height: 100%;\n}\n\n.daysGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n.dayButton {\n  width: var(--ibk-spacing-xxl, 64px);\n  height: var(--ibk-spacing-lg, 32px);\n  margin: 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: var(--ibk-colors-neutral-400, #e6e6e6);\n  border-radius: var(--ibk-radius-pill, 100px);\n  cursor: pointer;\n  font-family: var(--ibk-typography-fontFamilyBase, 'Source Sans 3', sans-serif);\n  font-weight: var(--ibk-typography-fontWeightRegular, 400);\n  font-size: var(--ibk-typography-fontSizeMd, 16px);\n  line-height: var(--ibk-typography-lineHeight160, 1.6);\n  color: var(--ibk-colors-neutral-900, #1f1f1f);\n}\n\n.dayDisabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.daySelected {\n  background: var(--ibk-colors-primary-orange-100, #ffeee5);\n  color: var(--ibk-colors-primary-orange-500, #d64000);\n  border: 1px solid var(--ibk-colors-primary-orange-500, #d64000);\n  gap: var(--ibk-spacing-xs, 4px);\n}\n\n.alertCloseButton {\n  height: var(--ibk-spacing-md, 16px);\n  width: var(--ibk-spacing-md, 16px);\n  color: var(--ibk-colors-primary-orange-500, #d64000);\n  text-align: center;\n  font-size: var(--ibk-typography-fontSizeSm, 12px);\n  background: transparent;\n  border: 1px solid var(--ibk-colors-primary-orange-500, #d64000);\n  cursor: pointer;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.iconCloseButton {\n  width: var(--ibk-spacing-xs, 8px);\n  height: var(--ibk-spacing-xs, 8px);\n  filter: var(--ibk-colors-primary-orange-filter, var(--primary-orange-filter));\n}\n\n.arrowButton {\n  border: none;\n  background: transparent;\n  color: var(--ibk-colors-primary-orange-500, #d64000);\n  font-size: var(--ibk-typography-fontSizeMd, 18px);\n  line-height: 1;\n  cursor: pointer;\n  width: var(--ibk-spacing-lg, 24px);\n  height: var(--ibk-spacing-lg, 24px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.select {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.selectButton {\n  height: 24px;\n  padding-right: var(--spacing-1-5);\n  padding-left: var(--spacing-1-5);\n  border-radius: var(--button-border-radius);\n  background: var(--brand-tr-orange);\n  border: 2px solid var(--brand-tr-orange);\n  color: var(--text-neutral-white);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--ibk-typography-fontSizeSm, 12px);\n  cursor: pointer;\n}\n\n/* Disabled styles */\n.popperContainerDisabled .textInputAndSvg {\n  border: none;\n}\n\n.popperContainerDisabled .textInput {\n  color: var(--disabled-subtle-text);\n  cursor: not-allowed;\n}\n\n.popperContainerDisabled .calendarIcon {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popper": `D23CJZ`,
	"popperContainer": `sTZR9H`,
	"title": `eLwwgJ`,
	"fields": `lfsTgA`,
	"singleField": `t9u2Xr`,
	"periodField": `WTIVe8`,
	"label": `d0Jbfu`,
	"textInputAndSvg": `HHAg7B`,
	"textInput": `tRRyEZ`,
	"calendar": `M2gQh8`,
	"calendarIcon": `GJahTR`,
	"arrow": `u_ATf_`,
	"calendarHeader": `o3KFE6`,
	"yearTitle": `ds6XMP`,
	"weekdays": `Yu8NI9`,
	"daysGrid": `oSolqN`,
	"dayButton": `ygdXHp`,
	"dayDisabled": `kqunSL`,
	"daySelected": `gySQ8y`,
	"alertCloseButton": `J5ux14`,
	"iconCloseButton": `euzGGJ`,
	"arrowButton": `joThtC`,
	"select": `g5EJMI`,
	"selectButton": `d0zEsr`,
	"popperContainerDisabled": `LpmVgB`
};
module.exports = ___CSS_LOADER_EXPORT___;
